import { PortalUserListAsyncView } from './view/PortalUserList.view';
import { usePortalUserListViewModel } from './view-model/PortalUserList.viewModel';
import { pageBackground } from '@client/new/pages/page-background.css';

const PortalUserListPage = () => {
  const vm = usePortalUserListViewModel({
    urlSearch: new URLSearchParams(window.location.search).get('q'),
  });
  return (
    <div className={pageBackground}>
      <PortalUserListAsyncView vm={vm} />
    </div>
  );
};

export default PortalUserListPage;
